<template>
  <div class="home-wrapper">
    <div style="display: flex; height: 200px; margin-bottom: 10px">
      <div class="count-totalcard">
        <!-- <div class="overlay"></div> -->
        <div class="totalcard-content">
          <div class="card-title">共检测</div>
          <count-to
            class="card-number"
            :start-val="0"
            :end-val="checkTotalNum"
            :duration="2000"
            :decimals="0"
          />
          <div class="card-unit">台</div>
        </div>
      </div>
      <div style="display: flex; flex: 1; flex-direction: column; margin: 0 1%">
        <div style="display: flex; width: 100%; justify-content: space-around">
          <!-- <div class="overlay"></div> -->
          <div
            class="count-totalcard"
            style="width: 42%; height: 120px; color: #000"
            :style="{
              background:
                'url(' +
                require('../../assets/imgs/card2.png') +
                ') no-repeat center center',
              'background-size': '100% 100%'
            }"
          >
            <div class="totalcard-content">
              <div class="card-title" style="color: #000">
                检测设备数(除吊篮)
              </div>
              <count-to
                style="color: #000"
                class="card-number"
                :start-val="0"
                :end-val="otherTotalCount"
                :duration="2000"
                :decimals="0"
              />
              <div class="card-unit" style="color: #000">台</div>
            </div>
          </div>

          <div
            class="count-totalcard"
            style="width: 42%; height: 120px"
            :style="{
              background:
                'url(' +
                require('../../assets/imgs/card3.png') +
                ') no-repeat center center',
              'background-size': '100% 100%'
            }"
          >
            <!-- <div class="overlay"></div> -->
            <div class="totalcard-content">
              <div class="card-title" style="color: #000">吊篮检测数</div>
              <count-to
                class="card-number"
                style="color: #000"
                :start-val="0"
                :end-val="basketTotalCount"
                :duration="2000"
                :decimals="0"
              />
              <div class="card-unit" style="color: #000">台</div>
            </div>
          </div>
        </div>
        <el-row class="header">
          <!-- <el-col
        :span="6"
        style="display: flex; justify-content: flex-start; align-items: center"
        ><span class="sideLine"></span>检测业务</el-col
      >
      <el-col :span="8">&nbsp;</el-col> -->

          <el-col :span="20">
            <div style="display: flex; align-items: center">
              <div>以下统计时间段：</div>
              <el-date-picker
                size="middle"
                v-model="pickerDate"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :editable="false"
                unlink-panels
                :picker-options="pickerOptions"
                @change="handleDateChange"
              >
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="2">
            <el-button
              type="info"
              plain
              size="mini"
              @click="changeRatioFn"
              style="height: 40px; margin: 11px 0 0 0"
              >转比率</el-button
            >
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- <el-row class="header">
      <el-col
        :span="6"
        style="display: flex; justify-content: flex-start; align-items: center"
        ><span class="sideLine"></span>检测业务</el-col
      >
      <el-col :span="8">&nbsp;</el-col>
      <el-col :span="2">
        <el-button
          type="info"
          plain
          size="mini"
          @click="changeRatioFn"
          style="height: 40px; margin: 11px 0 0 0"
          >转比率</el-button
        >
      </el-col>
      <el-col :span="8">
        <el-date-picker
          size="middle"
          v-model="pickerDate"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :editable="false"
          unlink-panels
          :picker-options="pickerOptions"
          @change="handleDateChange"
        >
        </el-date-picker>
      
      </el-col>
    </el-row> -->
    <div class="content">
      <div class="date-row">
        <div
          v-for="(item, index) in cardInfoData"
          :key="index"
          class="data-col"
        >
          <el-card shadow="always" :body-style="{ padding: '0px' }">
            <div class="date-block">
              <i
                :class="[item.icon]"
                :style="{ color: item.color, background: item.bgcolor }"
                class="icon-box iconfont"
              />
              <div class="date-cont">
                <CountTo
                  class="count"
                  :start-val="1000"
                  :autoplay="true"
                  :decimals="item.isDecimals"
                  :end-val="item.count"
                  :duration="2000"
                />
                <!-- <div class="count">{{ item.count }}</div> -->
                <div class="value" v-if="item.unit != '' || item.rate">
                  <p class="unit" v-if="item.unit != ''">{{ item.unit }}</p>
                  <!-- <p class="rate" v-if="item.rate">{{ item.rate }}</p> -->
                </div>
                <p class="title">{{ item.title }}</p>
              </div>
            </div>
          </el-card>
        </div>
      </div>
      <el-row class="date-box" :gutter="20">
        <el-col :span="8">
          <div class="data-chart">
            <!-- 1饼图 -->
            <ChartsPie
              :title="chartsPieTitle"
              type="ring"
              :data="chartsPieData"
            />
          </div>
        </el-col>
        <el-col :span="8">
          <div class="data-chart">
            <!-- 2渐变折线图 -->
            <!-- <ChartsgraLine :title="graLineTitle" :data="graLineData" /> -->
            <!-- <ChartsLine
              :title="lineTitle"
              :data="lineData"
              :color="ChartslineColor"
            /> -->
            <!-- <ChartsBar :title="lineTitle" :data="lineData" /> -->
            <DualYAxisChart
              :title="lineTitle"
              :data="lineData"
              leftName="设备数"
              rightName="安全分值"
            />
          </div>
        </el-col>
        <el-col :span="8">
          <div class="data-chart">
            <el-select
              v-model="deviceValue"
              placeholder="请选择"
              @change="changeBarType"
            >
              <el-option
                v-for="item in deviceTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <ChartsBar :title="ChartsmixTitle" :data="commonChartsData" />
          </div>
        </el-col>
      </el-row>
      <el-row class="date-box" :gutter="20" v-if="authAreaStatus">
        <el-col :span="14">
          <div class="data-chart">
            <el-select
              v-model="QueryAreaRateLabel"
              placeholder="请选择"
              @change="QueryAreaRateType"
              filterable
            >
              <el-option
                v-for="item in QueryAreaRateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>

            <ChartsmixBar
              :title="RegionalequRate"
              :data="RegionalequRateList"
            />
          </div>
        </el-col>
        <el-col :span="10">
          <div class="data-chart">
            <el-select
              v-model="QueryAreaNumLabel"
              placeholder="请选择"
              @change="QueryAreaNumType"
              filterable
            >
              <el-option
                v-for="item in QueryAreaNumList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <!-- 堆叠柱状图 -->
            <StackedColumn
              :title="TotalPassRateTitle"
              :data="TotalPassRateList"
            ></StackedColumn>
          </div>
        </el-col>
      </el-row>
      <el-row class="date-box" :gutter="20">
        <el-col :span="10">
          <div class="data-chart data-lang-box">
            <!-- <el-select
              v-if="authInstallStatus"
              v-model="SteelDefectsValue"
              placeholder="请选择"
              @change="SteelDefectsChange"
            >
              <el-option
                v-for="item in SteelDefectsValueType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <ChartstoperrBar
              :title="SteelDefectsTitle"
              :data="SteelDefectsList"
            ></ChartstoperrBar> -->
            <StackedColumn
              :title="tsqzjDmTitle"
              :data="tsqzjDmList"
            ></StackedColumn>
          </div>
        </el-col>
        <el-col :span="14">
          <!-- <div
            shadow="always"
            :body-style="{ padding: '0px' }"
            class="data-chart"
          >
            <ChartsPie :title="HiddenDangersTitle" :data="HiddenDangersList" />
          </div> -->
          <div class="data-chart">
            <StackedColumn
              :title="HiddenDangersTitle"
              :data="HiddenDangersList"
            ></StackedColumn>
          </div>
        </el-col>
      </el-row>
      <el-row class="date-box" :gutter="20">
        <el-col :span="13">
          <div class="data-chart">
            <el-select
              v-if="authInstallStatus"
              v-model="QuerytypeValue"
              placeholder="请选择"
              @change="changeQueryType"
            >
              <el-option
                v-for="item in QuerytypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <ChartsdimensionBar :title="CheckRate" :data="CheckRateList" />
          </div>
        </el-col>
        <el-col :span="11">
          <div class="data-chart">
            <StackedColumn
              :title="HiddenDangersNumTitle"
              :data="HiddenDangersNumList"
            ></StackedColumn>
          </div>
        </el-col>
      </el-row>
      <el-row class="date-box" :gutter="20">
        <el-col :span="14">
          <div class="data-chart data-lang-box">
            <el-select
              v-model="topCheckRateValue"
              placeholder="请选择"
              @change="topCheckRateChange"
            >
              <el-option
                v-for="item in topCheckRateType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <ChartstoperrBar
              :title="topCheckRate"
              :data="topCheckRateList"
            ></ChartstoperrBar>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="mask"></div>

    <div class="footer">
      <!-- <div class="titlemask">吊篮专区</div> -->
      <el-row class="date-box" :gutter="24">
        <el-col :span="12">
          <div class="data-extrachart">
            <div class="extraTitle">吊篮检测报告除权合格率</div>
            <div class="extrachart">
              <div style="width: 31%">
                <ChartsextraPie :title="dlCheckRate" :data="dlCheckRateList1" />
              </div>
              <div style="width: 31%">
                <ChartsextraPie :title="dlCheckRate" :data="dlCheckRateList2" />
              </div>
              <div style="width: 31%">
                <ChartsextraPie :title="dlCheckRate" :data="dlCheckRateList3" />
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <!-- <div class="data-chart">
            <ChartsextraPie :title="dlchartsPieTitle" :data="dlchartsPieData" />
          </div> -->
          <div class="data-extrachart">
            <div class="extraTitle">吊篮隐患项数与总台数</div>
            <div class="extrachart">
              <div style="width: 31%">
                <ChartsextraPie
                  :title="dlCheckRate"
                  :data="dlHiddenDangersNumList1"
                />
              </div>
              <div style="width: 31%">
                <ChartsextraPie
                  :title="dlCheckRate"
                  :data="dlHiddenDangersNumList2"
                />
              </div>
              <div style="width: 31%">
                <ChartsextraPie
                  :title="dlCheckRate"
                  :data="dlHiddenDangersNumList3"
                />
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="date-box" :gutter="20">
        <el-col :span="12">
          <div class="data-chart">
            <!-- <ChartsLine
              :title="dllineTitle"
              :data="dllineData"
              :color="ChartslineColor"
            /> -->
            <DualYAxisChart
              :title="dllineTitle"
              :data="dllineData"
              leftName="设备数"
              rightName="安全分值"
            />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="data-chart">
            <!-- 图3 -->
            <ChartsBar :title="dlChartsmixTitle" :data="dlcommonChartsData" />
          </div>
        </el-col>
      </el-row>
      <el-row class="date-box" :gutter="20" v-if="authAreaStatus">
        <el-col :span="14">
          <div class="data-chart">
            <el-select
              v-model="dlQueryAreaRateLabel"
              placeholder="请选择"
              @change="dlQueryAreaRateType"
              filterable
            >
              <el-option
                v-for="item in dlQueryAreaRateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <!-- 图4 -->
            <ChartsmixBar
              :title="dlRegionalequRate"
              :data="dlRegionalequRateList"
            />
          </div>
        </el-col>
        <el-col :span="10">
          <div class="data-chart">
            <!-- 堆叠柱状图 -->
            <el-select
              v-model="dlQueryAreaNumLabel"
              placeholder="请选择"
              @change="dlQueryAreaNumType"
              filterable
            >
              <el-option
                v-for="item in dlQueryAreaNumList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <StackedColumn
              :title="dlTotalPassRateTitle"
              :data="dlTotalPassRateList"
            ></StackedColumn>
          </div>
        </el-col>
      </el-row>
      <el-row class="date-box" :gutter="20">
        <el-col :span="14">
          <div class="data-chart data-lang-box">
            <ChartstoperrBar
              :title="dltopCheckRate"
              :data="dltopCheckRateList"
            ></ChartstoperrBar>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import CountTo from 'vue-count-to'
import ChartsPie from './components/ChartsPie.vue'
import ChartsextraPie from './components/ChartsextraPie'
import ChartsBar from './components/ChartsBar'
import ChartsmixBar from './components/ChartsmixBar'
// import ChartsLine from './components/ChartsLine'
// import ChartstopBar from './components/ChartstopBar'
import ChartstoperrBar from './components/ChartstoperrBar'
import StackedColumn from './components/StackedColumn'
import ChartsdimensionBar from './components/ChartsdimensionBar'
import DualYAxisChart from './components/DualYAxisChart'

import {
  getDeviceCounts,
  getNumberQualified,
  recheckQualified,
  averageNonconformities,
  onceQualified,
  getDeviceHiddenDangerCount,
  securityScore,
  getTotalNumberOfHiddenDangers,
  getDeviceTotalPassRate,
  queryTestReportByArea,
  queryTestReport,
  querySysData,
  getDeviceRatio,
  deviceTypeGeneralAndGuarantee,
  queryArea,
  // getNumberMonth,
  queryTestReportByYear,
  getNumberOfSteelDefects,
  getRectificationTop,
  numberOfDevices,
  getNumberAndScoreMonth,
  tsqzjDm,
  getDeviceTotalCount
} from '@/api/detection'
import { queryDashboardModule } from '@/api/users'
export default {
  name: 'Home',
  components: {
    CountTo,
    ChartsPie,
    ChartsBar,
    ChartsmixBar,
    // ChartsLine,
    ChartsextraPie,
    // ChartstopBar,
    ChartstoperrBar,
    // ChartsNightingale,
    ChartsdimensionBar,
    StackedColumn,
    DualYAxisChart
  },
  data() {
    return {
      // 日期选择器
      authIdList: [], // 权限id列表
      authAreaStatus: false, //按区域统计权限
      authInstallStatus: false, //按不同安装单位统计权限
      authUseStatus: false, //按不同使用单位统计权限
      pickerDate: [], //日期
      timeType: '2', //1年，2月份
      changeRatio: 1, //数据乘以85%处理还是默认1
      pickerDay: [],
      otherTotalCount: 0,
      basketTotalCount: 0,
      checkTotalNum: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        }
      },
      value: '',
      pieTypeValue: '4',
      NightingaleTitle: '设备数量及占比',
      chartsPieTitle: '设备数量及占比',
      lineTitle: '月度设备数和安全分值',
      ChartsmixTitle: '设备除权合格率',
      ChartslineColor: '#19be6b',
      deviceValue: '',
      deviceTypeList: [],
      // 区域设备量
      TotalPassRateTitle: '区域设备量',
      TotalPassRateList: {},
      // 区域设备合格率
      RegionalequRate: '区域设备除权合格率',
      RegionalequRateList: {},
      //区域
      QueryAreaNumValue: '',
      QueryAreaNumLabel: '',
      QueryAreaRateValue: '',
      QueryAreaRateLabel: '',
      QueryAreaNumList: [],
      QueryAreaRateList: [],
      cardInfoData: [
        {
          title: '检测设备',
          icon: 'icon-gongzuotongji',
          count: 1,
          unit: '',
          isDecimals: 0,
          color: '#667eea',
          bgcolor: 'rgba(102, 126, 234, 0.15)'
        },
        {
          title: '一次合格',
          icon: 'icon-shebeiOEE',
          count: 37833,
          unit: '',
          isDecimals: 0,
          color: '#19be6b',
          bgcolor: 'rgba(25, 190, 107, 0.15)'
        },
        {
          title: '复检合格',
          icon: 'icon-yewuzongliang',
          count: 0,
          unit: '',
          isDecimals: 0,
          color: '#ff9a9e',
          bgcolor: 'rgba(255, 154, 158, 0.15)'
        },
        {
          title: '不合格项',
          icon: 'icon-xiangmu1',
          count: 8970,
          unit: '',
          isDecimals: 0,
          color: '#fbc2eb',
          bgcolor: 'rgba(251, 194, 235, 0.15)'
        },
        {
          title: '整改项',
          icon: 'icon-icon_xinyong_xianxing_jijin-211',
          count: 979896,
          unit: '',
          isDecimals: 0,
          color: '#a18cd1',
          bgcolor: 'rgba(161, 140, 209, 0.15)'
        },
        {
          title: '安全分值',
          icon: 'icon-chartmixed',
          count: 100,
          unit: '',
          isDecimals: 2,
          color: '#84fab0',
          bgcolor: 'rgba(132, 250, 176, 0.15)'
        }
      ],
      // 检查合格率
      QuerytypeValue: '1',
      CheckRate: '检测报告除权合格率',
      QuerytypeList: [
        {
          value: '1',
          label: '设备类型'
        },
        {
          value: '2',
          label: '安装单位'
        }
      ],
      CheckRateList: {},
      // 整改项比率
      topCheckRateValue: '',
      topCheckRate: '整改项排名top10',
      topCheckRateType: [],
      topCheckRateList: [],
      // 隐患占比
      HiddenDangersTitle: '隐患占比（单位：%）',
      HiddenDangersList: {},
      // 隐患项数
      HiddenDangersNumTitle: '隐患项数',
      HiddenDangersNumList: {
        // deviceData: [
        //   {
        //     name: '吊篮',
        //     type: 'bar',
        //     label: {
        //       show: true
        //     },
        //     emphasis: {
        //       focus: 'series'
        //     },
        //     data: [24, 40, 15, 26, 61]
        //   },
        //   {
        //     name: '其他',
        //     type: 'bar',
        //     label: {
        //       show: true
        //     },
        //     emphasis: {
        //       focus: 'series'
        //     },
        //     data: [34, 10, 15, 30, 17]
        //   }
        // ],
        // area: ['建邺区', '鼓楼区', '雨花台区', '江宁区', '玄武区']
      },
      // 钢结构缺陷
      SteelDefectsTitle: '钢结构缺陷',
      SteelDefectsList: [],
      SteelDefectsValue: '1',
      SteelDefectsValueType: [
        {
          value: '0',
          label: '安装单位'
        },
        {
          value: '1',
          label: '厂家'
        }
      ],
      chartsPieData: [],
      lineData: {},
      commonChartsData: {},
      // 塔机吨米统计
      tsqzjDmTitle: '塔机不同吨米设备数',
      tsqzjDmList: {},
      // 吊篮专区
      dltopCheckRate: '吊篮整改项排名',
      dllineTitle: '吊篮月度设备数和安全分值',
      dlChartsmixTitle: '吊篮设备除权合格率',
      dlRegionalequRate: '吊篮区域设备除权合格率',
      dlTotalPassRateTitle: '吊篮区域设备量',
      dlCheckRate: '吊篮检测报告除权合格率',
      dlchartsPieTitle: '吊篮隐患项数',
      dlQueryAreaNumValue: '',
      dlQueryAreaNumLabel: '',
      dlQueryAreaRateLabel: '',
      dltopCheckRateList: [],
      dllineData: {},
      dlcommonChartsData: {},
      dlRegionalequRateList: {},
      dlTotalPassRateList: {},
      dlCheckRateList1: {},
      dlCheckRateList2: {},
      dlCheckRateList3: {},
      dlchartsPieData: [],
      dlQueryAreaNumList: [],
      dlQueryAreaRateList: [],
      dlHiddenDangersNumList1: {},
      dlHiddenDangersNumList2: {},
      dlHiddenDangersNumList3: {}
    }
  },
  created() {
    this.defaultTime()
    this.getDeviceTotalCount()
    this.queryDashboardModuleFn()
    this.getDeviceCountsFn()
    this.numberOfDevicesFn()
    // this.getNumberQualifiedFn()
    this.recheckQualifiedFn()
    this.onceQualifiedFn()
    this.averageNonconformitiesFn()
    this.getDeviceHiddenDangerCountFn()
    this.securityScoreFn()
    this.getTotalNumberOfHiddenDangersFn()
    // this.getDeviceRatioFn()
    this.deviceTypeGeneralAndGuaranteeFn()
    this.queryTestReportFn(this.QuerytypeValue)
    this.querySysDataFn()
    this.getQueryAreaFn()
    this.getQueryAreaRateFn()
    // this.getRectificationTopFn(this.topCheckRateValue)
    // this.queryTestReportByYearFn(this.deviceValue)
    this.getNumberOfSteelDefectsFn(this.SteelDefectsValue)
    this.getNumberMonthFn()
    this.dlgetRectificationTopFn()
    this.dlgetNumberMonthFn()
    this.dlqueryTestReportByYearFn()
    this.dlqueryTestReportFn()
    this.dlgetTotalNumberOfHiddenDangersFn()
    this.tsqzjDmFn()
  },
  watch: {},
  methods: {
    // 默认时间
    defaultTime() {
      if (this.pickerDate.length == 0) {
        // 默认当前日期之前365天
        let sdate = new Date()
        let interval = -365 //间隔天数
        let caret = '-' //日期分隔符
        let strYear = sdate.getFullYear()
        let strDay = sdate.getDate()
        let strMonth = sdate.getMonth() + 1
        let patt1 = /^\d{4}-([0-1]?[0-9])-([0-3]?[0-9])$/ //判断输入的日期是否符合格式正则表达式
        if (!(sdate && typeof sdate == 'string' && patt1.test(sdate))) {
          sdate = new Date() //不满足日期的则使用当前年月日
        }
        interval = isNaN(parseInt(interval)) ? 0 : parseInt(interval) //若没有输入间隔，则使用当前日
        caret = caret && typeof caret == 'string' ? caret : ''
        let gdate = new Date(sdate).getTime() //获取指定年月日
        gdate = gdate + 1000 * 60 * 60 * 24 * interval //加减相差毫秒数
        let speDate = new Date(gdate) //获取指定好毫秒数时间
        let preYear = speDate.getFullYear()
        let preMonth = speDate.getMonth() + 1
        let preDay = speDate.getDate()
        preMonth = preMonth < 10 ? '0' + preMonth : preMonth
        preDay = preDay < 10 ? '0' + preDay : preDay
        let preDate = preYear + caret + preMonth + caret + preDay
        this.pickerDate = [preDate, strYear + '-' + strMonth + '-' + strDay]
      }
    },
    // 获取当前登录用户的仪表盘展示id
    queryDashboardModuleFn() {
      queryDashboardModule().then((res) => {
        // console.log(res.data)
        this.authIdList = res.data.split(',')
        this.authAreaStatus = this.authIdList.find((number) => number == 1)
        this.authInstallStatus = this.authIdList.find((number) => number == 2)
        this.authUseStatus = this.authIdList.find((number) => number == 3)
      })
    },
    // 获取设备检测总台数
    getDeviceTotalCount() {
      getDeviceTotalCount({}).then((res) => {
        if (res.data) {
          this.checkTotalNum = res.data.totalCount
          this.basketTotalCount = res.data.basketCount
          this.otherTotalCount = res.data.otherCount
        }
      })
    },
    // 数据转换
    numberConversion(value) {
      var param = {}
      var k = 10000,
        sizes = ['', '万', '亿', '万亿'],
        i
      if (value < k) {
        param.value = value
        param.unit = ''
      } else {
        i = Math.floor(Math.log(value) / Math.log(k))

        param.value = (value / Math.pow(k, i)).toFixed(1)
        param.unit = sizes[i]
      }
      return param
    },
    // 随机颜色
    getColorByRandom(colorList) {
      var colorIndex = Math.floor(Math.random() * colorList.length)
      var color = colorList[colorIndex]
      colorList.splice(colorIndex, 1)
      return color
    },
    //选择日期事件
    handleDateChange(pickerDate) {
      if (pickerDate != null) {
        let Day_1 = Date.parse(pickerDate[0])
        let Day_2 = Date.parse(pickerDate[1])
        let diffDate = Math.abs(Day_1 - Day_2)
        let totoalDays = Math.floor(diffDate / (1000 * 3600 * 24))
        let month = Math.ceil(totoalDays / 30)
        if (1 <= month && month <= 24) {
          //小于两年,按月
          this.timeType = '2'
        } else if (month > 24) {
          //大于两年，按年
          this.timeType = '1'
        }
      } else {
        this.pickerDate = []
      }
      // this.pickerDate = []
      this.getNumberMonthFn()
      this.getDeviceCountsFn()
      this.numberOfDevicesFn()
      // this.getNumberQualifiedFn()
      this.recheckQualifiedFn()
      this.onceQualifiedFn()
      this.averageNonconformitiesFn()
      this.getDeviceHiddenDangerCountFn()
      this.securityScoreFn()
      this.getTotalNumberOfHiddenDangersFn()
      // this.getDeviceRatioFn()
      this.deviceTypeGeneralAndGuaranteeFn()

      this.queryTestReportFn(this.QuerytypeValue)
      this.querySysDataFn()
      this.getQueryAreaFn()
      this.getQueryAreaRateFn()
      // this.getRectificationTopFn(this.topCheckRateValue)
      // this.queryTestReportByYearFn(this.deviceValue)
      this.getNumberOfSteelDefectsFn(this.SteelDefectsValue)
      this.dlgetRectificationTopFn()
      this.dlgetNumberMonthFn()
      this.dlqueryTestReportByYearFn()
      this.dlqueryTestReportFn()
      this.dlgetTotalNumberOfHiddenDangersFn()
      this.tsqzjDmFn()
    },
    // 点击搜索
    search() {
      if (this.pickerDate.length == 0) {
        // console.log('请选择')
        this.$message({
          message: '请点击选框进行选择',
          type: 'warning'
        })
      } else {
        //数据请求
        this.getNumberMonthFn()
        this.getDeviceCountsFn()
        this.numberOfDevicesFn()
        // this.getNumberQualifiedFn()
        this.recheckQualifiedFn()
        this.onceQualifiedFn()
        this.averageNonconformitiesFn()
        this.getDeviceHiddenDangerCountFn()
        this.securityScoreFn()
        this.getTotalNumberOfHiddenDangersFn()
        // this.getDeviceRatioFn()
        this.deviceTypeGeneralAndGuaranteeFn()
        this.queryTestReportFn(this.QuerytypeValue)
        this.querySysDataFn()
        this.getQueryAreaFn()
        this.getQueryAreaRateFn()
        // this.getRectificationTopFn(this.topCheckRateValue)
        // this.queryTestReportByYearFn(this.deviceValue)
        this.getNumberOfSteelDefectsFn(this.SteelDefectsValue)
        this.dlgetRectificationTopFn()
        this.dlgetNumberMonthFn()
        this.dlqueryTestReportByYearFn()
        this.dlqueryTestReportFn()
        this.dlgetTotalNumberOfHiddenDangersFn()
        this.tsqzjDmFn()
      }
    },
    // 点击切换比率 转85
    changeRatioFn() {
      this.changeRatio === 1
        ? (this.changeRatio = 0.85)
        : (this.changeRatio = 1)
      this.onceQualifiedFn() //一次合格
      this.queryTestReportByYearFn(this.deviceValue) //设备除权合格率
      this.dlqueryTestReportByYearFn() //吊篮设备除权合格率
      this.queryTestReportByAreaFn(this.QueryAreaRateValue) //区域设备除权合格率
      this.dlqueryTestReportByAreaFn(this.dlQueryAreaRateValue) //吊篮区域设备除权合格率
      this.dlqueryTestReportFn() //吊篮检测报告除权合格率
      this.queryTestReportFn(this.QuerytypeValue) //检测报告除权合格率
    },
    //设备合格率下拉选择
    changeBarType(deviceValue) {
      // console.log(deviceValue)
      this.queryTestReportByYearFn(deviceValue)
    },
    //环形图下拉选择
    changePieType(pieTypeValue) {
      console.log(pieTypeValue)
    },
    //整改项对比下拉
    topCheckRateChange(topCheckRateValue) {
      this.getRectificationTopFn(topCheckRateValue)
    },
    // 钢结构缺陷下拉
    SteelDefectsChange(SteelDefectsValue) {
      // console.log(SteelDefectsValue)
      this.getNumberOfSteelDefectsFn(SteelDefectsValue)
    },
    // 区域设备量下拉
    QueryAreaNumType(QueryAreaNumValue) {
      // console.log(QueryAreaNumValue)
      this.getDeviceTotalPassRateFn(QueryAreaNumValue)
    },
    // 吊篮区域设备量下拉
    dlQueryAreaNumType(QueryAreaNumValue) {
      this.dlgetDeviceTotalPassRateFn(QueryAreaNumValue)
    },
    // 区域设备合格率下拉
    QueryAreaRateType(QueryAreaRateValue) {
      this.queryTestReportByAreaFn(QueryAreaRateValue)
    },
    // 吊篮区域设备合格率下拉
    dlQueryAreaRateType(QueryAreaRateValue) {
      this.dlqueryTestReportByAreaFn(QueryAreaRateValue)
    },
    changeQueryType(QuerytypeValue) {
      this.queryTestReportFn(QuerytypeValue)
    },
    // 获取设备类型
    querySysDataFn() {
      querySysData().then((res) => {
        this.deviceTypeList = res.data
        this.deviceValue = this.deviceTypeList[0].value
        this.queryTestReportByYearFn(this.deviceValue)
        this.topCheckRateType = res.data
        this.topCheckRateValue = this.deviceTypeList[0].value
        this.getRectificationTopFn(this.topCheckRateValue)
      })
    },
    // 区域设备量查看区域
    getQueryAreaFn() {
      let getQueryAreaData = {
        region: ''
      }
      queryArea(getQueryAreaData).then((res) => {
        this.QueryAreaNumList = res.data.map((itm) => {
          return { label: itm.region, value: itm.city }
        })
        // this.QueryAreaNumValue = this.QueryAreaNumList[0].value
        // this.QueryAreaNumLabel = this.QueryAreaNumList[0].label
        let areanumId = this.QueryAreaNumList.map((itm) => {
          return Object.values(itm).indexOf('江苏省苏州市')
        })
        let areanumValue = areanumId.indexOf(0)
        this.QueryAreaNumValue = this.QueryAreaNumList[areanumValue].value
        this.QueryAreaNumLabel = this.QueryAreaNumList[areanumValue].label
        this.getDeviceTotalPassRateFn(this.QueryAreaNumValue)

        this.dlQueryAreaNumList = res.data.map((itm) => {
          return { label: itm.region, value: itm.city }
        })
        let dlareanumId = this.dlQueryAreaNumList.map((itm) => {
          return Object.values(itm).indexOf('江苏省苏州市')
        })
        let dlareanumValue = dlareanumId.indexOf(0)
        this.dlQueryAreaNumValue = this.dlQueryAreaNumList[dlareanumValue].value
        this.dlQueryAreaNumLabel = this.dlQueryAreaNumList[dlareanumValue].label
        this.dlgetDeviceTotalPassRateFn(this.dlQueryAreaNumValue)
      })
    },
    // 区域设备合格率查看区域
    getQueryAreaRateFn() {
      let getQueryAreaData = {
        region: ''
      }
      queryArea(getQueryAreaData).then((res) => {
        this.QueryAreaRateList = res.data.map((itm) => {
          return { label: itm.region, value: itm.city }
        })
        // this.QueryAreaRateValue = this.QueryAreaRateList[2].value
        // this.QueryAreaRateLabel = this.QueryAreaRateList[2].label
        let areaId = this.QueryAreaRateList.map((itm) => {
          return Object.values(itm).indexOf('江苏省苏州市')
        })
        let areaValue = areaId.indexOf(0)
        this.QueryAreaRateValue = this.QueryAreaRateList[areaValue].value
        this.QueryAreaRateLabel = this.QueryAreaRateList[areaValue].label
        this.queryTestReportByAreaFn(this.QueryAreaRateValue)
        // 吊篮
        this.dlQueryAreaRateList = res.data.map((itm) => {
          return { label: itm.region, value: itm.city }
        })
        let dlareaId = this.dlQueryAreaRateList.map((itm) => {
          return Object.values(itm).indexOf('江苏省苏州市')
        })
        let dlareaValue = dlareaId.indexOf(0)
        this.dlQueryAreaRateValue = this.dlQueryAreaRateList[dlareaValue].value
        this.dlQueryAreaRateLabel = this.dlQueryAreaRateList[dlareaValue].label
        this.dlqueryTestReportByAreaFn(this.dlQueryAreaRateValue)
      })
    },
    // 查看检测设备总台数
    numberOfDevicesFn() {
      let numberOfDevicesData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        isBasket: '2' //是否包含吊篮
      }
      numberOfDevices(numberOfDevicesData).then((res) => {
        // 检测设备总台数
        // this.cardInfoData[0].count = Number(res.data[0].count)
        let zerocount = this.numberConversion(res.data[0].count)
        this.cardInfoData[0].count = Number(zerocount.value)
        if (zerocount.unit) {
          this.cardInfoData[0].isDecimals = 1
          this.cardInfoData[0].unit = zerocount.unit
        }
      })
    },
    // 查看检测设备数量及占比
    getDeviceCountsFn() {
      let getDeviceCountsData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        isBasket: '2' //是否包含吊篮
      }
      getDeviceCounts(getDeviceCountsData).then((res) => {
        this.chartsPieData = res.data.map((itm) => {
          return { value: itm.value, name: itm.name }
        })
      })
    },
    // 查看一次合格
    onceQualifiedFn() {
      // radio 比率，点击转比率切换1和0.85
      let onceQualifiedData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        isBasket: '2' //是否包含吊篮
      }
      onceQualified(onceQualifiedData).then((res) => {
        // this.cardInfoData[1].count = Number(res.data.count)
        let onecount = this.numberConversion(res.data.count)
        this.cardInfoData[1].count = Number(onecount.value * this.changeRatio)
        if (onecount.unit) {
          this.cardInfoData[1].isDecimals = 1
          this.cardInfoData[1].unit = onecount.unit
        }
        // this.cardInfoData[1].rate = '/' + res.data.ratio
      })
    },
    // 查看检测设备合格项
    getNumberQualifiedFn() {
      let getNumberQualifiedData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        isBasket: '2' //是否包含吊篮
      }
      getNumberQualified(getNumberQualifiedData).then((res) => {
        console.log(res)
      })
    },
    // 查看复检合格
    recheckQualifiedFn() {
      let recheckQualifiedData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        isBasket: '2' //是否包含吊篮
      }
      recheckQualified(recheckQualifiedData).then((res) => {
        // this.cardInfoData[2].count = Number(res.data.count)
        let twocount = this.numberConversion(res.data.count)
        this.cardInfoData[2].count = Number(twocount.value)
        if (twocount.unit) {
          this.cardInfoData[2].isDecimals = 1
          this.cardInfoData[2].unit = twocount.unit
        }
        // this.cardInfoData[2].rate = '/' + res.data.ratio
        // console.log('复检', res)
      })
    },
    // 查看平均不合格项
    averageNonconformitiesFn() {
      let averageNonconformitiesData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        isBasket: '2' //是否包含吊篮
      }
      averageNonconformities(averageNonconformitiesData).then((res) => {
        // this.cardInfoData[3].count = Number(res.data.count)
        let threecount = this.numberConversion(res.data.count)
        this.cardInfoData[3].count = Number(threecount.value)
        if (threecount.unit) {
          this.cardInfoData[3].isDecimals = 1
          this.cardInfoData[3].unit = threecount.unit
        }
        // this.cardInfoData[3].rate = '/' + res.data.ratio
        // console.log('平均不合格项', res)
      })
    },

    // 查看整改总数
    getDeviceHiddenDangerCountFn() {
      let getDeviceHiddenDangerCountData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        isBasket: '2' //是否包含吊篮
      }
      getDeviceHiddenDangerCount(getDeviceHiddenDangerCountData).then((res) => {
        // this.cardInfoData[4].count = Number(res.data.count)
        let fourcount = this.numberConversion(res.data.count)
        this.cardInfoData[4].count = Number(fourcount.value)
        if (fourcount.unit) {
          this.cardInfoData[4].isDecimals = 1
          this.cardInfoData[4].unit = fourcount.unit
        }
        // console.log('隐患项', res)
      })
    },
    // 查看安全分值
    securityScoreFn() {
      let securityScoreData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        isBasket: '2' //是否包含吊篮
      }
      securityScore(securityScoreData).then((res) => {
        if (res.data.value) {
          let fivecount = this.numberConversion(res.data.value)
          this.cardInfoData[5].count = Number(fivecount.value)
          // console.log('安全分', fivecount)
        }
      })
    },
    // 所有设备得隐患总数，不同设备得隐患数，和比值
    getTotalNumberOfHiddenDangersFn() {
      let getTotalNumberOfHiddenDangersData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        isBasket: '2' //是否包含吊篮
      }
      getTotalNumberOfHiddenDangers(getTotalNumberOfHiddenDangersData).then(
        (res) => {
          this.HiddenDangersNumList = res.data
        }
      )
    },
    // 不同设备得隐患数，和比值
    getDeviceRatioFn() {
      let getDeviceRatioData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        isBasket: '2' //是否包含吊篮
      }
      getDeviceRatio(getDeviceRatioData).then((res) => {
        // if (res.data.length > 0) {
        //   this.cardInfoData[2].count = Number(res.data[0].total)
        // }
        this.HiddenDangersList = res.data.map((itm) => {
          return { value: itm.value, name: itm.label }
        })
      })
    },
    deviceTypeGeneralAndGuaranteeFn() {
      let deviceTypeGeneralAndGuaranteeData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        isBasket: '2' //是否包含吊篮
      }
      deviceTypeGeneralAndGuarantee(deviceTypeGeneralAndGuaranteeData).then(
        (res) => {
          this.HiddenDangersList = res.data
        }
      )
    },
    // 查看月度设备数量
    getNumberMonthFn() {
      if (this.pickerDate.length == 0) {
        // 默认当前月之前12个月
        // console.log('12个月')
        let dataArr = []
        let data = new Date()
        data.setMonth(data.getMonth() + 1, 1) //获取到当前月份,设置月份
        for (var i = 0; i < 12; i++) {
          data.setMonth(data.getMonth() - 1) //每次循环一次 月份值减1
          let m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + m)
        }
        // console.log(dataArr)
        this.pickerDay = [
          dataArr[dataArr.length - 1] + '-01',
          dataArr[0] + '-01'
        ]
      }
      let getNumberMonthData = {
        startDt: this.pickerDate[0] || this.pickerDay[0],
        endDt: this.pickerDate[1] || this.pickerDay[1],
        timeType: this.timeType, //1:年，2：月
        isBasket: '2' //是否包含吊篮
      }
      getNumberAndScoreMonth(getNumberMonthData).then((res) => {
        if (res.data && res.data.length > 0) {
          let dataObj = {}

          let datas = res.data
          dataObj.xData = datas.map((i) => i.month)
          dataObj.leftData = datas.map((i) => i.totalCount)
          dataObj.rightData = datas.map((i) => i.safetyScore)

          this.lineData = dataObj
        } else {
          this.lineData = {}
        }
      })
    },
    // 不同区域设备总数
    getDeviceTotalPassRateFn(city) {
      let getDeviceTotalPassRateData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        city,
        isBasket: '2' //是否包含吊篮
      }
      getDeviceTotalPassRate(getDeviceTotalPassRateData).then((res) => {
        this.TotalPassRateList = res.data
      })
    },
    // 根据区域查看设备合格率
    queryTestReportByAreaFn(city) {
      let queryTestReportByAreaData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        city
      }
      queryTestReportByArea(queryTestReportByAreaData).then((res) => {
        // this.RegionalequRateList = res.data
        let datas = res.data
        if (datas.deviceData && datas.deviceData.length > 0) {
          datas.deviceData.forEach((el) => {
            if (el.data && el.data.length > 0) {
              el.data = el.data.map((ele) => {
                return (ele * this.changeRatio).toFixed(1)
              })
            }
          })
        }
        this.RegionalequRateList = datas
      })
    },
    // 根据不同维度查看检测报告合格率
    queryTestReportFn(dimension) {
      let queryTestReportData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        dimension,
        isBasket: '2' //是否包含吊篮
      }
      queryTestReport(queryTestReportData).then((res) => {
        // this.CheckRateList = res.data
        let datas = res.data
        if (datas.data && datas.data.length > 0) {
          datas.data.forEach((el) => {
            if (el.data && el.data.length > 0) {
              el.data = el.data.map((ele) => {
                return (ele * this.changeRatio).toFixed(1)
              })
            }
          })
        }
        this.CheckRateList = datas
      })
    },
    // 相同类型的不同年限的产品合格率，设备除权合格率
    queryTestReportByYearFn(deviceType) {
      let queryTestReportByYearData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        deviceType,
        isBasket: '2' //是否包含吊篮
      }
      queryTestReportByYear(queryTestReportByYearData).then((res) => {
        // this.commonChartsData = res.data[0]
        if (res.data && res.data.length > 0) {
          let dataObj = {}
          dataObj.xAxisData = Object.keys(res.data[0])
          let datas = Object.values(res.data[0])
          dataObj.seriesData = datas.map((itm) => {
            return itm.pcl * this.changeRatio
          })
          dataObj.seriesList = datas.map((itm) => {
            return itm.count
          })
          this.commonChartsData = dataObj
        } else {
          this.commonChartsData = {}
        }
      })
    },
    // 整改中出现频率最高的前10项
    getRectificationTopFn(deviceType) {
      let getRectificationTopData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        deviceType,
        isBasket: '2', //是否包含吊篮
        order: 'DESC'
      }
      getRectificationTop(getRectificationTopData).then((res) => {
        this.topCheckRateList = res.data.map((itm) => {
          return { value: itm.ratio, name: itm.name, count: itm.value }
        })
      })
    },
    // 不同厂家/不同安装单位 设备出现钢结构缺陷数量
    getNumberOfSteelDefectsFn(unit) {
      let getNumberOfSteelDefectsData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        unit,
        order: 'DESC'
      }
      getNumberOfSteelDefects(getNumberOfSteelDefectsData).then((res) => {
        this.SteelDefectsList = res.data.map((itm) => {
          return { value: itm.ratio, name: itm.name, count: itm.count }
        })
      })
    },

    // 吊篮专区
    // 整改中出现频率最高的前10项
    dlgetRectificationTopFn() {
      let getRectificationTopData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        isBasket: '1', //是否包含吊篮
        order: 'DESC'
      }
      getRectificationTop(getRectificationTopData).then((res) => {
        this.dltopCheckRateList = res.data.map((itm) => {
          return { value: itm.ratio, name: itm.name, count: itm.value }
        })
      })
    },
    // 查看月度设备数量
    dlgetNumberMonthFn() {
      if (this.pickerDate.length == 0) {
        // 默认当前月之前12个月
        let dataArr = []
        let data = new Date()
        data.setMonth(data.getMonth() + 1, 1) //获取到当前月份,设置月份
        for (var i = 0; i < 12; i++) {
          data.setMonth(data.getMonth() - 1) //每次循环一次 月份值减1
          let m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + m)
        }
        this.pickerDay = [
          dataArr[dataArr.length - 1] + '-01',
          dataArr[0] + '-01'
        ]
      }
      let getNumberMonthData = {
        startDt: this.pickerDate[0] || this.pickerDay[0],
        endDt: this.pickerDate[1] || this.pickerDay[1],
        timeType: this.timeType, //1:年，2：月
        isBasket: '1', //是否包含吊篮
        deviceType: '1'
      }
      getNumberAndScoreMonth(getNumberMonthData).then((res) => {
        if (res.data && res.data.length > 0) {
          let dataObj = {}

          let datas = res.data
          dataObj.xData = datas.map((i) => i.month)
          dataObj.leftData = datas.map((i) => i.totalCount)
          dataObj.rightData = datas.map((i) => i.safetyScore)

          this.dllineData = dataObj
        } else {
          this.dllineData = {}
        }
      })
    },
    // 不同区域设备总数
    dlgetDeviceTotalPassRateFn(city) {
      let dlgetDeviceTotalPassRateData = {
        startDt: this.pickerDate[0] || this.pickerDay[0],
        endDt: this.pickerDate[1] || this.pickerDay[1],
        city,
        isBasket: '1', //是否包含吊篮
        deviceType: '1'
      }
      getDeviceTotalPassRate(dlgetDeviceTotalPassRateData).then((res) => {
        this.dlTotalPassRateList = res.data
      })
    },
    // 相同类型的不同年限的产品合格率
    dlqueryTestReportByYearFn() {
      let dlqueryTestReportByYearData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        // deviceType,
        isBasket: '3' //是否包含吊篮
      }
      queryTestReportByYear(dlqueryTestReportByYearData).then((res) => {
        // this.dlcommonChartsData = res.data[0]
        if (res.data && res.data.length > 0) {
          let dataObj = {}
          dataObj.xAxisData = Object.keys(res.data[0])
          let datas = Object.values(res.data[0])
          dataObj.seriesData = datas.map((itm) => {
            return itm.pcl * this.changeRatio
          })
          dataObj.seriesList = datas.map((itm) => {
            return itm.count
          })
          this.dlcommonChartsData = dataObj
        } else {
          this.dlcommonChartsData = {}
        }
      })
    },
    // 根据区域查看设备合格率
    dlqueryTestReportByAreaFn(city) {
      let dlqueryTestReportByAreaData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        city,
        isBasket: '3' //是否包含吊篮
      }
      queryTestReportByArea(dlqueryTestReportByAreaData).then((res) => {
        // this.dlRegionalequRateList = res.data
        let datas = res.data
        if (datas.deviceData && datas.deviceData.length > 0) {
          datas.deviceData.forEach((el) => {
            if (el.data && el.data.length > 0) {
              el.data = el.data.map((ele) => {
                return (ele * this.changeRatio).toFixed(1)
              })
            }
          })
        }
        this.dlRegionalequRateList = datas
      })
    },
    // 根据不同维度查看检测报告合格率
    dlqueryTestReportFn() {
      let dlqueryTestReportData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        dimension: '1',
        isBasket: '3' //是否包含吊篮
      }
      queryTestReport(dlqueryTestReportData).then((res) => {
        let checkrates = res.data.data
        checkrates.forEach((el) => {
          if (el.data && el.data.length > 0) {
            let datas = (parseFloat(el.data.join()) * this.changeRatio).toFixed(
              1
            )
            el.data = (datas.toString() + '%').split()
          }
        })
        // console.log()
        this.dlCheckRateList1 = checkrates[0]
        this.dlCheckRateList2 = checkrates[1]
        this.dlCheckRateList3 = checkrates[2]
      })
    },
    // 所有设备得隐患总数，不同设备得隐患数，和比值
    dlgetTotalNumberOfHiddenDangersFn() {
      let dlgetTotalNumberOfHiddenDangersData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1],
        isBasket: '1', //是否包含吊篮
        deviceType: '1'
      }
      getTotalNumberOfHiddenDangers(dlgetTotalNumberOfHiddenDangersData).then(
        (res) => {
          if (res.data.deviceData.length > 0) {
            let hiddenData1 = res.data.deviceData[0]
            this.dlHiddenDangersNumList1 = {
              name: hiddenData1.name,
              data: hiddenData1.value.replace(/%/g, '').split(),
              Counts: hiddenData1.Counts
            }
            let hiddenData2 = res.data.deviceData[1]
            this.dlHiddenDangersNumList2 = {
              name: hiddenData2.name,
              data: hiddenData2.value.replace(/%/g, '').split(),
              Counts: hiddenData2.Counts
            }
            let hiddenData3 = res.data.deviceData[2]
            this.dlHiddenDangersNumList3 = {
              name: hiddenData3.name,
              data: hiddenData3.value.replace(/%/g, '').split(),
              Counts: hiddenData3.Counts
            }
          }
        }
      )
    },
    // 塔机吨米统计
    tsqzjDmFn() {
      let tsqzjDmData = {
        startDt: this.pickerDate[0],
        endDt: this.pickerDate[1]
      }
      tsqzjDm(tsqzjDmData).then((res) => {
        this.tsqzjDmList = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home-wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px;
  background: #f0f2f5;
  min-height: 100%;

  .header {
    justify-content: space-between;
    margin-top: 10px;
    display: flex;
    align-items: center;
    font-size: 16px;
    height: 60px;
    line-height: 60px;
    color: #4a4848;
    width: 100%;
    background: #fff;
    border-radius: 12px;
    padding: 0 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

    .sideLine {
      width: 8px;
      height: 36px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 4px;
      margin-right: 10px;
      margin-left: 10px;
    }
  }

  .count-totalcard {
    width: 30%;
    height: 200px;
    border-radius: 16px;
    overflow: hidden;
    background-size: cover;
    position: relative;
    transition: all 0.3s ease;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  }

  .count-card:hover {
    transform: translateY(-4px);
  }

  .overlay {
    position: absolute;
    inset: 0;
  }

  .totalcard-content {
    position: relative;
    z-index: 2;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .card-title {
    font-size: 18px;
    font-weight: 500;
    color: #fff;
    margin-bottom: 10px;
  }

  .card-number {
    font-size: 38px;
    font-weight: bold;
    color: #fff;
    animation: numberPop 0.5s ease-in-out;
  }

  .card-unit {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.9);
    margin-top: 6px;
  }

  @keyframes numberPop {
    0% {
      transform: scale(0.8);
      opacity: 0.5;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  .date-row {
    display: flex;
    margin-bottom: 20px;

    .data-col {
      flex: 1;
      width: 16%;
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
      .el-card {
        border-radius: 12px;
        border: none;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
        transition: all 0.3s ease;
        &:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
        }
      }
      .date-block {
        display: flex;
        align-items: center;
        height: 120px;
        .icon-box {
          font-size: 40px;
          width: 40%;
          height: 120px;
          text-align: center;
          line-height: 120px;
          color: #fff;
        }
        .date-cont {
          flex: 1;
          text-align: center;
          color: #515a6e;

          .count {
            line-height: 70px;
            padding: 12px 0;
            font-size: 35px;
            font-weight: 600;
          }
          .value {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: -10px;
            .unit {
              font-size: 14px;
            }
            .rate {
              color: #878d94;
              font-size: 14px;
            }
          }

          .title {
            text-align: center;
            font-size: 16px;
            color: #666;
          }
        }
      }
    }
  }

  .date-box {
    margin-bottom: 20px;
  }

  .data-desc {
    width: 100%;
    height: 500px;
    position: relative;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    .el-select {
      position: absolute;
      z-index: 10;
      right: 10px;
      top: 10px;
      width: 30%;
    }
  }

  .data-chart {
    width: 100%;
    height: 400px;
    position: relative;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    .el-select {
      position: absolute;
      z-index: 10;
      right: 10px;
      top: 10px;
      width: 30%;
    }
  }

  .data-extrachart {
    width: 100%;
    height: 200px;
    position: relative;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    padding: 20px 0 10px 0;
    .extrachart {
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      flex: 1;
    }
    .extraTitle {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      color: #333;
    }
  }

  .data-lang-box {
    padding: 10px 15px;
    box-sizing: border-box;
    .data-lang-title {
      line-height: 32px;
      font-size: 16px;
      text-align: center;
      margin-bottom: 10px;
    }
    .data-lang-item {
      height: 48px;
      line-height: 20px;
    }
  }

  .mask {
    overflow: hidden;
    height: 20px;
  }

  .titlemask {
    color: #667eea;
    font-size: 24px;
    font-weight: 600;
    position: relative;
    text-align: center;
    margin-bottom: 20px;
  }

  .titlemask:before,
  .titlemask:after {
    content: '';
    position: absolute;
    display: block;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    border-top: 4px solid #667eea;
    width: 30px;
  }

  .titlemask:before {
    margin-left: -80px;
  }

  .titlemask::after {
    margin-left: 80px;
  }
}
</style>
